/**
 * Este método itera sobre un objeto hasta encontrar la ruta especificada
 *
 * @example
 *
  const obj = {
    a: {
      b: {
        c: {
          d: "d"
        }
      }
    }
  };

  console.log(getValueByPath(obj,'a.b.c')) // { d: 'd' }
  console.log(getValueByPath(obj,'a.b.c.d')) // 'd'
 *
 */
export function getValueByPath(
  obj: Record<string, unknown>,
  path: string | string[],
  separator = '.',
): unknown {
  const actualPath = typeof path === 'string' ? path.split(separator) : path;
  if (typeof obj !== 'object' || !obj) {
    if (actualPath.length === 0) return obj;
    return undefined;
  }
  const currentStep = actualPath.shift() as string;
  if (actualPath.length === 0) return obj[currentStep];
  return getValueByPath(
    obj[currentStep] as Record<string, unknown>,
    actualPath,
    separator,
  );
}
